import React from 'react';
import { Helmet } from 'react-helmet';

export interface BlogPost {
  title: string;
  description: string;
  href: string;
}

export interface DynamicJsonLdProps {
  canonicalUrl: string;
  nextPageUrl?: string;
  prevPageUrl?: string;
  tagFriendlyName: string;
  blogPosts: BlogPost[];
}

const DynamicJsonLd: React.FC<DynamicJsonLdProps> = ({
  canonicalUrl,
  nextPageUrl,
  prevPageUrl,
  tagFriendlyName,
  blogPosts
}) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": `Blogs for small business: ${tagFriendlyName} | Insureon`,
        "url": canonicalUrl,
        "mainEntity": {
          "@type": "ItemList",
          "numberOfItems": blogPosts.length,
          "itemListElement": blogPosts.map((post, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
              "@type": "BlogPosting",
              "headline": post.title,
              "url": post.href,
              "description": post.description
            }
          }))
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd, null, 2)}
      </script>
    </Helmet>
  );
};

export default DynamicJsonLd;
